import type { VueConstructor } from 'vue';
import { SystemList, SystemCard, IntegrationCard, FieldTokenList, JsonEditor } from './components';
import IntegrationCreateCard from './components/ConnectorService/IntegrationCreateCard.vue';
import './plugins/fontawesome-brands.js';

// Import global styles
// import './assets/styles/global.css';

// Export all components for individual import
export * from './components';

// Create install function for Vue.use()
const plugin = {
  install(HostVue: VueConstructor, options?: { vuetify: any }) {
    if (!options || !options.vuetify) {
      console.error('Vuetify instance is not provided during plugin installation!');
      return;
    }

    // Make the host's Vuetify instance available globally via the prototype.
    // This is the standard way to make plugins available to all components.
    HostVue.prototype.$vuetify = options.vuetify;
    

    // Create component constructors that explicitly inject the host's Vuetify
    // instance. This is a more robust method than relying on the prototype
    // and is necessary to ensure the context is available in a mixed
    // Vite/Webpack environment.
    const components = {
      SystemList,
      SystemCard,
      IntegrationCard,
      IntegrationCreateCard,
      FieldTokenList,
      JsonEditor,
    };

    Object.keys(components).forEach(name => {
      // Type assertion to handle both ComponentOptions and VueConstructor components
      HostVue.component(name, components[name as keyof typeof components] as any);
    });
  },
};

// Export the plugin
export default plugin;
